import { useState } from 'react'
import Button from '@components/atoms/Button'
import Tag from '@components/atoms/Tag'
import { scopedTranslation } from '@frontend/utils/I18n'

const t = scopedTranslation('components.supporter_tags_list')

type TagType = {
  name: string
}

type SupporterTagsListProps = {
  tags: TagType[]
  maxVisibleTags?: number
}

export function SupporterTagsList({ tags, maxVisibleTags = 3 }: SupporterTagsListProps) {
  const [showAll, setShowAll] = useState(false)

  const visibleTags = showAll ? tags : tags.slice(0, maxVisibleTags)
  const hiddenTagsCount = tags.length - maxVisibleTags

  return (
    <div className="tw:max-w-[90%]">
      <div className="tw:flex tw:flex-wrap tw:gap-2 tw:transition-all tw:duration-300 tw:ease-in-out">
        {visibleTags.map((tag, index) => (
          <div key={`${tag.name}-${index}`} className="tw:flex tw:items-center tw:min-h-7">
            <Tag size="sm" color="grayscale">
              {tag.name}
            </Tag>
          </div>
        ))}

        {(hiddenTagsCount > 0 || showAll) && (
          <div className="tw:flex tw:items-center tw:min-h-7">
            {!showAll && hiddenTagsCount > 0 && (
              <Button
                onClick={() => setShowAll(true)}
                rank="link"
                size="sm"
              >
{t('expand_tags', { count: hiddenTagsCount })}
              </Button>
            )}

            {showAll && tags.length > maxVisibleTags && (
              <Button
                onClick={() => setShowAll(false)}
                rank="link"
                size="sm"
              >
{t('collapse_tags')}
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
